<template>
    <div class="loading">
        <div style="width: 40%;height: 30px;margin: 0 0 0 48px;display: flex">
            <div style="width: 100%;height: 100%">
                <el-progress :stroke-width="30" :percentage="percentage" :color="customColorMethod" :show-text="true"></el-progress>
            </div>
            <i style="font-size: 30px" class="el-icon-loading"></i>
        </div>
        <span v-if="textType == 2">正在上传...</span>
<!--        <p v-if="textType != 2"><img src="../../assets/img/loading.gif" alt=""></p>-->
        <span v-else>正在加载...</span>
    </div>
</template>
<script>
    export default {
        props:{
            textType:{
                type:Number
            }
        },
        data(){
            return {
                percentage:0,
                customColor: '#409eff',
                customColors: [
                    {color: '#f56c6c', percentage: 20},
                    {color: '#e6a23c', percentage: 40},
                    {color: '#5cb87a', percentage: 60},
                    {color: '#1989fa', percentage: 80},
                    {color: '#6f7ad3', percentage: 100}
                ]
            }
        },
        mounted() {
            this.$nextTick(()=>{
                const interval = setInterval(()=>{
                    if(this.percentage >= 99){
                        clearInterval(interval);
                        return;
                    }
                    this.percentage += 1;
                },20)
            })
        },
        methods:{
            customColorMethod(percentage) {
                if (percentage < 30) {
                    return '#909399';
                } else if (percentage < 70) {
                    return '#e6a23c';
                } else {
                    return '#67c23a';
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    .loading{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.7);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p{
            width: 300px;
            height: 300px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        span{
            font-size: 25px;
            margin: 20px 0 0 0;
        }
        .el-progress{
            display: flex;
            align-items: center;
        }
    }
</style>